/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { piDependencies } from './dependenciesPi.generated.js';
import { createUppercasePi } from '../../factoriesAny.js';
export var PIDependencies = {
  piDependencies,
  createUppercasePi
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesUppercasePi.generated.js
// module id = A0u9
// module chunks = 3